import React, { useState } from "react";
import AddCategoryForm from "../AddCategoryForm/AddCategoryForm";
import { Typography } from "@material-ui/core";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Link } from "react-router-dom";
import { useStyles } from "../../../assets/styles";

export const NEW = "Agregar Nuevo";
export const EDIT = "Editar existente";
export const DELETE = "Borrar existente";

export default function CategoryAction(props) {
	const [action, setAction] = useState("");

	const handleClick = (action) => {
		setAction(action);
	};

	const returnAction = () => {
		setAction("");
	};
	const classes = useStyles();

	const returnButton = (
		<Link to="/menu" style={{ textDecoration: "none" }}>
			<ButtonWithStyle className={classes.returnButton}>
				<ArrowBackIosIcon />
				Regresar
			</ButtonWithStyle>
		</Link>
	);

	return (
		<>
			{!action ? (
				<>
					<Typography variant="h5">Seleccione una acción</Typography>
					<ButtonWithStyle onClick={() => handleClick(NEW)}>{NEW}</ButtonWithStyle>
					<ButtonWithStyle onClick={() => handleClick(EDIT)}>{EDIT}</ButtonWithStyle>
					<ButtonWithStyle onClick={() => handleClick(DELETE)}>{DELETE}</ButtonWithStyle>
					{returnButton}
				</>
			) : (
				<AddCategoryForm action={action} returnAction={returnAction} {...props} />
			)}
		</>
	);
}
